import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getUserGroupList = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/get-group/?deleted=0`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering
        },
    });
};
const getArchiveGroupsList = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/get-group/?deleted=1`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering
        },
    });
};
const getGroupById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/get-group/${id}`, {headers: authHeader()});
};
const createGroup = (payload) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/get-group/`,
        payload, // Payload for the request body
        {
            headers: authHeader(),
        },
    );
};
const updateGroup = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/get-group/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        {headers: authHeader()}, // Authentication header
    );
};

const archiveGroup = (id) => {
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/get-group/${id}/`, // Include `id` in the URL
        {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
            },
        }
    );
};
const unArchiveGroup = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/get-group/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const userGroupService = {
    getUserGroupList,
    getArchiveGroupsList,
    getGroupById,
    createGroup,
    updateGroup,
    archiveGroup,
    unArchiveGroup
};

export default userGroupService;
